import React from "react";

interface SmallArrowDropDownIconProps {
  color?: string;
}
export default function SmallArrowDropDownIcon(props?: SmallArrowDropDownIconProps) {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill={props?.color ? props.color : "none"}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 3.62L6 9.5L11.25 3.62"
        stroke={props?.color ? props.color : "#002035"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
